import { render, staticRenderFns } from "./ItemSalesProfit.vue?vue&type=template&id=3127018c"
import script from "./ItemSalesProfit.vue?vue&type=script&lang=js"
export * from "./ItemSalesProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports